/**
 * Spinner component set to replace
 * https://www.npmjs.com/package/react-loaders-spinners
 */
import "../../styles/SpinLoader.css";
const SpinLoader = ({
  width = 50,
  height = 50,
  thickness = 10,
  sColor = "#f3f3f3",
  pColor = "#555",
}) => {
  return (
    <div
      className="spin-loader"
      style={{
        borderRadius: "50%",
        width: `${width}px`,
        height: `${height}px`,
        border: `${thickness}px solid ${sColor}`,
        borderTop: `${thickness}px solid ${pColor}`,
        boxSizing: "border-box",
        display: "inline-block",
      }}
    ></div>
  );
};

export default SpinLoader;
